<template>
  <div class="tcard" :class="{ 'tcard--closed': isClosed, 'tcard--blocked': isBlocked }">
    <div class="tcard__top">
      <span class="tcard__id">T‑{{ card.id }}</span>
      <span v-if="card.overdue" class="tcard__badge">Просрочена</span>
      <span v-if="card.closedAt" class="tcard__closed">закрыта {{ card.closedAt }}</span>
      <span v-if="card.blockedAt" class="tcard__closed tcard__blocked">отменена {{ card.blockedAt }}</span>
    </div>
    <div class="tcard__title" :title="card.objectName">{{ card.title }}</div>
    <div class="tcard__meta">{{ card.assignee }} · дедлайн {{ card.deadline }}</div>
    <ul v-if="card.works.length" class="tcard__works">
      <li v-for="(w, i) in card.works" :key="i" class="tcard__work" :class="{ 'tcard__work--done': w.done }">{{ w.title }}</li>
    </ul>
    <div v-if="card.dispatcherComment" class="tcard__comment tcard__comment--dispatcher"><b>Диспетчер.</b> {{ card.dispatcherComment }}</div>
    <div v-if="card.engineerComment" class="tcard__comment tcard__comment--engineer"><b>Инженер.</b> {{ card.engineerComment }}</div>
    <div class="tcard__actions">
      <template v-if="!isClosed && !isBlocked">
        <button type="button" class="btn btn-success btn-sm tcard__edit" :disabled="locked" @click="act('edit')">
          <span v-if="spinning('edit')" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Изменить
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm tcard__cancel" :disabled="locked" @click="act('cancel')">
          <span v-if="spinning('cancel')" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Отменить
        </button>
      </template>
      <button v-else-if="isBlocked" type="button" class="btn btn-light btn-sm tcard__resume" :disabled="locked" @click="act('resume')">
        <span v-if="spinning('resume')" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Вернуть в работу
      </button>
      <button v-else type="button" class="btn btn-light btn-sm tcard__reopen" :disabled="locked" @click="act('reopen')">
        <span v-if="spinning('reopen')" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Открыть повторно
      </button>
      <button
        type="button"
        class="btn btn-light btn-sm tcard__focus"
        :disabled="!card.canFocus"
        :title="card.canFocus ? null : 'У объекта нет координат'"
        @click="$emit('focus', card)"
      >На карте</button>
    </div>
  </div>
</template>

<script>
/**
 * One board card (KOP-38 spec §6.4). Dumb: renders a `cardModel()` and emits the action
 * with the card; the owner decides what happens. `pending` marks this card's request in flight.
 */
export default {
  name: 'TaskCard',
  props: {
    card: { type: Object, required: true },
    pending: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { pendingAction: null }; // which button started the pending request
  },
  computed: {
    isClosed() { return this.card.kind === 'closed'; },
    isBlocked() { return this.card.kind === 'blocked'; },
    locked() { return this.disabled || this.pending; },
  },
  watch: {
    pending(v) { if (!v) this.pendingAction = null; },
  },
  methods: {
    act(name) {
      this.pendingAction = name;
      this.$emit(name, this.card);
    },
    spinning(name) { return this.pending && this.pendingAction === name; },
  },
};
</script>

<style scoped lang="scss">
.tcard { background: #fff; border: 1px solid #e3e5e1; border-radius: 10px; padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
.tcard__top { display: flex; align-items: center; gap: 8px; }
.tcard__id { font-family: SFMono-Regular, Menlo, monospace; font-size: 12px; color: #8b918c; }
.tcard__badge { background: #fbeae5; color: #c0492b; font-size: 10.5px; font-weight: 800; padding: 2px 6px; border-radius: 5px; }
.tcard__closed { margin-left: auto; font-size: 11.5px; color: #8b918c; }
.tcard__title { font-weight: 700; font-size: 14px; color: #1d221f; }
.tcard__meta { color: #8b918c; }
.tcard__works { list-style: none; padding: 0; margin: 2px 0 0; display: flex; flex-direction: column; gap: 3px; }
.tcard__work { position: relative; padding-left: 16px; &::before { content: ''; position: absolute; left: 2px; top: 6px; width: 8px; height: 8px; border-radius: 50%; background: #c3c8c3; } }
.tcard__work--done::before { background: #17876f; }
.tcard__comment { background: #f4f5f1; border-radius: 8px; padding: 8px 10px; color: #4c524d; b { color: #8b918c; font-weight: 700; } }
.tcard__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 4px; }
.tcard__actions .btn-light { border: 1px solid #e3e5e1; }
</style>
